<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-card title="Crear nuevos usuarios">
        <b-card-body style="display: flex">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="model.title" class="form-control" placeholder="Titulo">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <input v-model="model.message" class="form-control" placeholder="Mensaje">
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <select v-model="model.type" class="form-control">
                  <option :value="null">SELECCIONE DESTINO </option>
                  <option value="SOLICITAR TRANSACCION">SOLICITAR TRANSACCION</option>
                  <option value="SOLICITAR TARJETA GO">(SOLO EBANX)SOLICITAR TARJETA GO (DESPUES DE LLENAR DATOS)</option>
                  <option value="RECARGAR TARJETA GO">(SOLO EBANX)RECARGAR TARJETA GO</option>
                </select>
              </b-col>
            </b-row>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <b-row class="form-group">
              <b-col md="10">
                <select v-model="model.icon" class="form-control">
                  <option :value="null">SELECCIONE ALERTA</option>
                  <option value="success">SUCCESS</option>
                  <option value="warning">ADVERTENCIA</option>
                  <option value="info">INFORMACION</option>
                  <option value="error">ERROR</option>
                </select>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <b-checkbox v-model="model.default">Hacer notificacion por default</b-checkbox>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="10">
                <img :src="urlImg"/>
              </b-col>
            </b-row>
          </div>

        </b-card-body>
        <b-row>
          <b-col class="text-right">
            <b-button variant="primary" @click="createUser">Guardar</b-button>
            <b-button variant="primary" @click="preview">VER PREVIEW</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {post} from "@/util/axiosRequest";

export default {
  name: "Create",
  data: () => ({
    model: {
      title: null,
      message: null,
      icon: null,
      type: null,
      default: false
    },
    urlImg: null,
  }),
  methods: {
    createUser() {
      if (this.model.title !== null && this.model.message !== null && this.model.icon !== null && this.model.type !== null) {
        post("notifications/create", this.model, true).then(({data}) => {
          this.clear()
          this.showMessage('Informacion guardada')
        })
      } else {
        this.showMessage('Todos los campos son requeridos', 'error')
      }
    },
    clear() {
      this.model = {
        title: null,
        message: null,
        icon: null,
        type: null,
        default: false
      }
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
    preview() {
      this.$swal({
        title: this.model.title,
        html: this.model.message,
        icon: this.model.icon,
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      })
    }
  }
}
</script>

<style scoped>

</style>
